import routes from "./routes"

const PGP_KEY_URL =
  "https://keys.openpgp.org/vks/v1/by-fingerprint/EC529BECDB5D0585E25F0A9A80322E028C82F84D"

export { routes, PGP_KEY_URL }
